<template>
  <div class="box">
    <div class="box-inner">
      <div class="item"
        :class="{
          'is-selected': item.selected,
          'disabled': item.disabled,
          [`${item.classname}-wrapper`]: true
        }"
        v-for="(item, i) in items" :key="i"
        @click="onItemClicked(item)"
      >
        <div>
          <i v-if="item.type === 'none'" class="no-anim"></i>
          <i v-else class="is-short" :class="{[`icon-${item.name}-anim`]: true}"></i>
        </div>
        <span>{{item.text}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sprite: {
      default () {
        return {}
      },
      type: Object
    }
  },
  data () {
    return {
      items: [
        {text: '无动效', disabled: false, type: 'none', name: 'none', classname: 'icon-path-anim', selected: false},
        {text: '动画路径', disabled: false, type: 'pathAnim', name: 'path', classname: 'icon-path-anim', selected: false},
        {text: '旋转', disabled: false, type: 'whirl', name: 'Whirl', classname: 'icon-whirl-anim', selected: false},
        {text: '抖动', disabled: false, type: 'shake', name: 'Shake', classname: 'icon-shake-anim', selected: false}
      ]
    }
  },
  methods: {
    render () {
      let effect = this.sprite.effect;
      if (!effect.pathAnim.target && effect.stayAnim.type === 'None') {
        this.pickItem('none');
        return;
      }
      if (effect.pathAnim.target) {
        this.pickItem('pathAnim');
        return;
      }

      if (effect.stayAnim.type !== 'None') {
        let t = effect.stayAnim.type.toLowerCase();
        this.pickItem(t);
      }
    },
    pickItem (type) {
      this.items.map((item) => {
        if (item.type === type) {
          this.$set(item, 'selected', true);
        } else {
          this.$set(item, 'selected', false);
        }
      });
    },

    onItemClicked (item) {
      this.$emit('onItemClicked', item);
    }
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  padding-top: 8px;
  text-align: center;
}

.box-inner {
  display: inline-block;
  width: 220px;
  margin-left: 2px;
  text-align: left;
}

.item {
  display: inline-block;
  margin-top: 16px;
  margin-right: 18px;
  text-align: center;
  cursor: pointer;

  &:nth-of-type(3n) {
    margin-right: 0;
  }
  &:nth-of-type(1), &:nth-of-type(2), &:nth-of-type(3) {
    margin-top: 0;
  }

  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 58px;
    background: #eff1f8;
    border-radius: 4px;
  }

  &.is-selected {
    & > div {
      border: 1.5px #5779fa solid;
    }
  }

  > span {
    display: block;
    margin-top: 6px;
  }
}

.no-anim {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  &:before {
    content: " ";
    position: absolute;
    height: 1px;
    width: 110px;
    background-color: red;
    transform: rotate(-45deg) translatex(-60px) translatey(-19px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/effectSetting/boxOne.vue